import { EvergreenCommunityListingAvailability } from "@sp-crm/core";
import React from "react";
import { useCanRequestCommunityAvailability } from "store/selectors/hooks";
import { ListableCommunity } from "../props";
import { LayoutItemAvailabilityExisting } from "./layout-item-availability-existing";
import { LayoutItemAvailabilityMissing } from "./layout-item-availability-missing";

interface LayoutItemAvailabilityProps {
    community: ListableCommunity;
}

export const LayoutItemAvailability: React.FC<LayoutItemAvailabilityProps> = props => {
    const { community } = props;
    const { isAvailabilityAllowed } = community;
    const canRequestAvailability = useCanRequestCommunityAvailability();

    if (!isAvailabilityAllowed) {
        return null;
    }

    const hasAvailability =
        !!community.availability?.status &&
        community.availability?.status !== EvergreenCommunityListingAvailability.Unknown;

    return (
        <div className="sm:col-span-1">
            <dt className="text-sm font-medium text-gray-500">Has vacancy?</dt>
            {hasAvailability ? (
                <LayoutItemAvailabilityExisting
                    community={community}
                    canRequestAvailability={canRequestAvailability}
                />
            ) : (
                <LayoutItemAvailabilityMissing
                    community={community}
                    canRequestAvailability={canRequestAvailability}
                />
            )}
        </div>
    );
};
